var map = {
	"./audio-placeholder": 831,
	"./audio-placeholder.png": 831,
	"./avatar-missing": 394,
	"./avatar-missing.png": 394,
	"./avatar-missing.svg": 883,
	"./header-missing": 395,
	"./header-missing.png": 395,
	"./soapbox-logo": 396,
	"./soapbox-logo-white": 397,
	"./soapbox-logo-white.svg": 397,
	"./soapbox-logo.svg": 396,
	"./video-placeholder": 832,
	"./video-placeholder.png": 832,
	"./void": 833,
	"./void.png": 833,
	"./web-push/web-push-icon_expand": 860,
	"./web-push/web-push-icon_expand.png": 860,
	"./web-push/web-push-icon_favourite": 861,
	"./web-push/web-push-icon_favourite.png": 861,
	"./web-push/web-push-icon_reblog": 862,
	"./web-push/web-push-icon_reblog.png": 862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 882;